import React from "react";

const MapComponent = () => {
  return (
    <div
      style={{
        marginTop: "30px",
        textAlign: "center",
        borderRadius: "8px",
        padding: "20px",
        backgroundColor: "#f9f9f9",
      }}
    >
      {/* Heading */}
      <h2
        style={{
          fontSize: "2rem",
          color: "rgba(35, 120, 97, 1)",
          fontFamily: "'Work Sans', sans-serif",
          fontWeight: "700",
          marginBottom: "20px",
        }}
      >
        Our Location
      </h2>

      {/* Map Section with iframe */}
      <div style={{ marginBottom: "20px", borderRadius: "8px", overflow: "hidden" }}>
        <iframe
          title="Google Map Location"
          src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d58399.63833190227!2d86.34644119182992!3d23.819402827327917!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1738908891231!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: "0", borderRadius: "8px" }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      {/* Link to Open in Google Maps */}
      <a
        href="https://goo.gl/maps/9zDgzhtthc2e44xQ9"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-block",
          marginTop: "10px",
          color: "#2361a5",
          textDecoration: "none",
          fontWeight: "bold",
          fontSize: "1.2rem",
        }}
      >
        
      </a>
    </div>
  );
};

export default MapComponent;
